import { styled, svgIconClasses } from '@mui/material';
import Box, { BoxProps } from '@mui/material/Box';
import IconButton, { iconButtonClasses, IconButtonProps } from '@mui/material/IconButton';

import { NEW_DISPATCH_TOPBAR_CONTROLS_HEIGHT_IN_PX } from '~constants/filters';

export const SmallIconButton = styled(IconButton)<IconButtonProps>(
  ({ theme, disabled }) => ({
    [`&.${iconButtonClasses.root}`]: {
      border: `solid 1px ${theme.brandV2.colors.treadGray7}`,
      borderRadius: theme.spacing(0.5),
      color: theme.brandV2.colors.treadBlack,
      height: `${NEW_DISPATCH_TOPBAR_CONTROLS_HEIGHT_IN_PX}px`,
      padding: '2px',
      width: `${NEW_DISPATCH_TOPBAR_CONTROLS_HEIGHT_IN_PX}px`,
      [`.${svgIconClasses.root}`]: {
        color: disabled ? theme.brandV2.colors.treadGray5 : undefined,
        fontSize: '18px',
      },
    },
  }),
);

export const ImageUploaderDashedBox = styled(Box, {
  shouldForwardProp: (propName) => propName !== 'isDisabled',
})<BoxProps & { isDisabled?: boolean }>(({ isDisabled, theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.semantic.surfaceOverlay,
  border: `dashed 3px ${theme.brandV2.colors.treadGray7}`,
  borderRadius: theme.spacing(),
  cursor: isDisabled ? 'not-allowed' : 'pointer',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
  height: '100%',
  justifyContent: 'center',
  overflow: 'hidden',
  padding: theme.spacing(3),
  width: '100%',
}));

export const TicketDetailsBox = styled(Box)(({ theme }) => ({
  border: `solid 1px ${theme.brandV2.colors.treadGray7}`,
  borderRadius: theme.spacing(1),
  padding: theme.spacing(1.5, 2, 2),
}));
